import { Avatar, Modal } from 'antd';
import styled from 'styled-components';
import { SuccessModalContent } from './success-modal-content.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Title = styled.span.withConfig({
  displayName: "success-modal-assignmentcomponent__Title",
  componentId: "sc-wfmrr5-0"
})(["font-weight:600;font-size:20px;margin-left:11px;align-items:center;"]);
var StyledSuccessModal = styled(Modal).withConfig({
  displayName: "success-modal-assignmentcomponent__StyledSuccessModal",
  componentId: "sc-wfmrr5-1"
})([".ant-modal-content{border-radius:20px;}"]);
export var renderSuccessModal = function renderSuccessModal(props) {
  var assignmentInfo = props.assignmentInfo,
      createAssignmentTranslation = props.createAssignmentTranslation,
      shareAssignmentTranslation = props.shareAssignmentTranslation,
      sharedLink = props.sharedLink,
      onCloseSuccessModal = props.onCloseSuccessModal,
      label = props.label,
      successIconUrl = props.successIconUrl;
  StyledSuccessModal.success({
    content: /*#__PURE__*/_jsx(SuccessModalContent, {
      assignmentInfo: assignmentInfo,
      sharedLink: sharedLink,
      shareAssignmentTranslation: shareAssignmentTranslation,
      label: label
    }),
    icon: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Avatar, {
        src: successIconUrl,
        size: "large"
      }), /*#__PURE__*/_jsx(Title, {
        children: createAssignmentTranslation.createdAssignmentSuccess
      })]
    }),
    okText: shareAssignmentTranslation.close,
    onOk: onCloseSuccessModal
  });
};